import React, { Component } from 'react';
export default class Footer extends Component {
    render() {
      return (
        <React.Fragment>
        {/*generated code*/}
                <footer>
                <div className="row">
                <div className="col-six tab-full pull-right social">
                    <ul className="footer-social">        
                    <li><a href="https://www.facebook.com/peddygriano/"><i className="fa fa-facebook" /></a></li>
                    <li><a href="https://www.linkedin.com/in/nicknshe/"><i className="fa fa-linkedin" /></a></li>
                    <li><a href="https://twitter.com/snickeret"><i className="fa fa-twitter" /></a></li>
                    <li><a href="https://www.reddit.com/user/prawnick"><i className="fa fa-reddit" /></a></li>
                    <li><a href="https://www.instagram.com/im_nicksome/"><i className="fa fa-instagram" /></a></li>
                    </ul> 
                </div>
                <div className="col-six tab-full">
                    <div className="copyright">
                    <span><a href="https://www.youtube.com/embed/YMYRVvwpdkA?autoplay=1">©</a> Nikhil Gupta <a href="https://www.youtube.com/embed/CxC161GvMPc?autoplay=1">2020</a>. </span> 
                    <span>Design by <a href="http://www.styleshout.com/">styleshout</a></span>
                    </div>		                  
                </div>
                <div id="go-top">
                    <a className="smoothscroll" title="Back to Top" href="#top"><i className="fa fa-long-arrow-up" /></a>
                </div>
                </div> {/* /row */}     	
            </footer>
        </React.Fragment>
      );
    }
  }